export function ucfirst(name) {
	if (!name || !name.trim()) {
		return name;
	}
	return name[0].toUpperCase() + name.slice(1);
}
